<div class="container" id="collections">
  <div class="row">
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-end justify-between gap-4">
        <div class="title-wr">
          <h1 data-testid="collections-header-title" class="section-title">{{ 'COLLECTIONS.TITLE' | translate }}</h1>
          <p data-testid="collections-header-subtitle" class="section-subtitle mt-1 text-base">{{ 'COLLECTIONS.SUBTITLE' | translate }}</p>
        </div>
        <div class="flex items-end justify-between gap-3 actions-wr">

          <!-- Sort panel toggle -->
          <app-sort-panel
            data-testid="sort-panel"
            [columns]="sortableColumns"
            [currentSort]="sortPanelSort"
            (sortChange)="onSortPanelChange($event)">
          </app-sort-panel>

          <!-- Filters toggle -->
          <button type="button" data-testid="btn-toggle-filters" class="btn outline-btn filters-btn" (click)="filtersPanel.toggleOpen()">
            {{ filtersPanel.isOpen ? ('FILTERS_PANEL.HIDE_FILTERS' | translate) : ('FILTERS_PANEL.DISPLAY_FILTERS' | translate) }}
          </button>

          @if (allowNewCollection) {
            <button data-testid="btn-new-collection" class="btn primary-btn" (click)="goToCreateCollectionForm()">{{ 'COLLECTIONS.BTN_NEW' |
            translate }}</button>
          }
        </div>
      </div>

      <!-- Filters panel -->
      <app-filters-panel
        #filtersPanel
        [columns]="tableColumns"
        [storageKeyStrategy]="'tableName'"
        [tableName]="collectionsTableName"
        (panelChange)="onFiltersPanelChange($event)">
      </app-filters-panel>

      <hr role="presentation" class="w-full mb-3 border-t" [class.mt-6]="!filtersPanel.isOpen" [class.mt-1]="filtersPanel.isOpen">

      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <!-- main content -->
            @if (tableColumns?.length) {
              <p-table data-testid="table" [columns]="tableColumns" [value]="data" (onLazyLoad)="customSort($event)" [lazy]="true" [customSort]="true" [sortField]="primeTableSortField" [sortOrder]="primeTableSortOrder">
                <ng-template #header let-columns>
                  <tr>
                    @for (col of columns; track col; let colIndex = $index) {
                      <!-- Normal sortable columns -->
                      @if (colIndex !== columns.length - 1 && col.sortable !== false) {
                        <th [pSortableColumn]="col.field">
                          <div class="header-wr">
                            <span [attr.data-testid]="'table-header-' + colIndex" class="col-name">
                              {{ ('TABLE.HEADER.' + col.header) | translate }}
                            </span>
                            <span class="sort-icon" aria-hidden="true">
                              @if (isColumnUnsorted(col.field)) {
                                <i class="pi pi-sort-alt"></i>
                              }
                              @if (isColumnSortedAsc(col.field)) {
                                <i class="pi pi-sort-amount-up-alt"></i>
                              }
                              @if (isColumnSortedDesc(col.field)) {
                                <i class="pi pi-sort-amount-down-alt"></i>
                              }
                            </span>
                          </div>
                        </th>
                      }
                      <!-- Non-sortable columns -->
                      @if (colIndex !== columns.length - 1 && col.sortable === false) {
                        <th>
                          <div class="header-wr">
                            <span [attr.data-testid]="'table-header-' + colIndex" class="col-name">
                              {{ ('TABLE.HEADER.' + col.header) | translate }}
                            </span>
                          </div>
                        </th>
                      }
                      <!-- Actions column -->
                      @if (colIndex === columns.length - 1) {
                        <th>
                          <span data-testid="table-header-actions" class="col-name">{{ ('TABLE.HEADER.' + col.field) | translate }}</span>
                        </th>
                      }
                    }
                  </tr>
                </ng-template>
                <ng-template #body let-rowData let-columns="columns" let-i="rowIndex">
                  <tr>
                    @for (col of columns; track col; let colIndex = $index) {
                      <td [ngClass]="{'actions-col': colIndex === columns.length -1}">
                        @if (colIndex !== columns.length-1) {
                          <span class="p-column-title">{{ ('TABLE.HEADER.' + col.header) | translate  }}:</span>
                          <span [attr.data-testid]="'cell-' + colIndex + '-' + i">{{ tableSettingService.getColumnValue(rowData, col) | defaultValue }}</span>
                        } @else {
                          <div class="flex">
                            <button type="button" pTooltip="{{ 'COLLECTIONS.TOOLTIP_VIEW_DETAILS' | translate }}" tooltipPosition="top"
                              class="btn-icon-only ui-btn-view btn-icon icon-eye"
                              (click)="goToCollectionDetails($event, rowData.id)"
                              [attr.data-testid]="'btn-view-' + i">
                              <span class="btn-label">{{ 'COLLECTIONS.VIEW_COLLECTION_DETAILS' | translate }}</span>
                            </button>
                          </div>
                        }
                      </td>
                    }
                  </tr>
                </ng-template>
                <ng-template #emptymessage>
                  @if (tableColumns) {
                    <tr>
                      <td [attr.colspan]="tableColumns!.length">{{ 'COLLECTIONS.NO_DATA' | translate }}</td>
                    </tr>
                  }
                </ng-template>
              </p-table>
              <!-- Pagination -->
              <app-custom-paginator
                data-testid="paginator"
                [pageNumber]="pageNumber"
                [rows]="pageSize"
                [totalRecords]="page?.totalCount ?? 0"
                [rowsPerPageOptions]="[10, 20, 30]"
                [showCurrentPageReport]="true"
                [currentPageReportTemplate]="'PAGINATOR.CURRENT_PAGE_REPORT' | translate"
                [disabled]="!page"
                [alwaysShow]="true"
                [tableName]="collectionsTableName"
                [showFirstLastIcon]="true"
                [showPageLinks]="true"
                [showPageSizeSelector]="true"
                (onPageChange)="onPageChange($event)">
              </app-custom-paginator>
            } @else {
              <div class="flex flex-col items-center justify-center gap-1 py-10 text-center no-cols-wr" role="status"
                data-testid="no-columns-message">
                <p class="text-base font-semibold">{{ 'TABLE.NO_COLUMNS_TITLE' | translate }}</p>
                <p class="text-base">{{ 'TABLE.NO_COLUMNS_MESSAGE' | translate }}</p>
              </div>
            }
            <!-- /main content -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
